const Banks = [
  { name: 'Page MFBank' },
  { name: 'Stanbic Mobile Money' },
  { name: 'FortisMobile' },
  { name: 'TagPay' },
  { name: 'FBNMobile' },
  { name: 'First Bank of Nigeria' },
  { name: 'Sterling Mobile' },
  { name: 'Omoluabi Mortgage Bank' },
  { name: 'ReadyCash (Parkway)' },
  { name: 'Zenith Bank' },
  { name: 'Standard Chartered Bank' },
  { name: 'eTranzact' },
  { name: 'Fidelity Bank' },
  { name: 'CitiBank' },
  { name: 'Unity Bank' },
  { name: 'Access Money' },
  { name: 'Eartholeum' },
  { name: 'Hedonmark' },
  { name: 'MoneyBox' },
  { name: 'JAIZ Bank' },
  { name: 'Ecobank Plc' },
  { name: 'EcoMobile' },
  { name: 'Fidelity Mobile' },
  { name: 'TeasyMobile' },
  { name: 'NIP Virtual Bank' },
  { name: 'VTNetworks' },
  { name: 'Stanbic IBTC Bank' },
  { name: 'Fortis Microfinance Bank' },
  { name: 'PayAttitude Online' },
  { name: 'ZenithMobile' },
  { name: 'ChamsMobile' },
  { name: 'SafeTrust Mortgage Bank' },
  { name: 'Covenant Microfinance Bank' },
  { name: 'Imperial Homes Mortgage Bank' },
  { name: 'NPF MicroFinance Bank' },
  { name: 'Parralex' },
  { name: 'Wema Bank' },
  { name: 'Enterprise Bank' },
  { name: 'Diamond Bank' },
  { name: 'Paycom' },
  { name: 'SunTrust Bank' },
  { name: 'Cellulant' },
  { name: 'ASO Savings and & Loans' },
  { name: 'Heritage' },
  { name: 'Jubilee Life Mortgage Bank' },
  { name: 'GTBank Plc' },
  { name: 'Union Bank' },
  { name: 'Sterling Bank' },
  { name: 'Polaris Bank' },
  { name: 'Keystone Bank' },
];

export default Banks;
